export default function addCustomColumn(array, options) {
    const { index, Header = () => null, accessor = null, Cell = null, sortType = 'basic', enableRowSpan = false, style = {}, id, } = options || {};
    array.push({
        index,
        ...(id && { id }),
        ...(accessor && { accessor }),
        ...(Cell && { Cell }),
        Header,
        sortType,
        enableRowSpan,
        style,
    });
}
